import { ENDPOINTS } from "config/endpoints";
import { useMutation, useQueryClient } from "react-query";
import Error from "types/error";
import client from "utils/client";
import { Request } from "types/request";
import { Response } from "types/response";
import { generatePath } from "react-router-dom";

export default function useDeleteUser() {
  const queryClient = useQueryClient();

  const deleteUser = (id: string) => {
    const request: Request = {
      url: generatePath(ENDPOINTS.users.user, { id }),
      config: {
        method: "delete",
      },
    };
    return client(request);
  };

  const { data, mutate, ...rest } = useMutation<Response<null>, Error, string>(
    deleteUser,
    {
      onSettled: (data, error, id) => {
        queryClient.invalidateQueries([ENDPOINTS.users.one, id]);
        queryClient.invalidateQueries([ENDPOINTS.users.all]);
      },
    }
  );

  return { data, mutate, ...rest };
}
